import React from "react";

const SendButton = ({
  isNextButtonVisible,
  isNextButtonLoading,
  clickButton,
  pageIndex,
  formData,
}) => {
  return (
    <React.Fragment>
      {isNextButtonVisible && (
        <div
          className={`app-button text-center ${isNextButtonLoading && `app-button-loading app-button-disable`}`}
          onClick={() => !isNextButtonLoading && clickButton(formData, pageIndex)}
        >
          <div className="d-inline">ENVOYER</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default SendButton;
